export default __webpack_public_path__ + "static/media/element_80.f793b4a8.webp";